import { Switch, Route, Redirect } from 'react-router-dom';

// Layouts
import BasicLayout from './layouts/BasicLayout';

// App Routes
import BookingPage from './containers/BookingPage';
import ReceiptPage from './containers/ReceiptPage';
import PaymentFailedPage from './containers/PaymentFailedPage';
import PaymentCallbackPage from './containers/PaymentCallbackPage';
import NotFoundPage from './containers/NotFoundPage';
import TermsConditionsPage from './containers/TermsConditionsPage';

// Helpers
import GeneralHelper from './helpers/general';

const routes = [
	// App Routes
	{ path: '/booking', exact: true, Layout: BasicLayout, Component: BookingPage, allowAfterCutoff: true },
	{ path: '/receipt', exact: true, Layout: BasicLayout, Component: ReceiptPage, allowAfterCutoff: true },
	{ path: '/payment-failed', exact: true, Layout: BasicLayout, Component: PaymentFailedPage, allowAfterCutoff: true },
	{ path: '/callback/payment', exact: true, Layout: BasicLayout, Component: PaymentCallbackPage, allowAfterCutoff: true },
	{ path: '/not-found', exact: true, Layout: BasicLayout, Component: NotFoundPage, allowAfterCutoff: true },
	{ path: '/terms', exact: true, Layout: BasicLayout, Component: TermsConditionsPage, allowAfterCutoff: true }
];

const Routes = ({ location }) => {
	const isPastCutoff = GeneralHelper.isPastOrderCutoffTime();

	return (
		<Switch location={location}>
			{routes.map(({ path, exact, Layout, Component, allowAfterCutoff }) => (
				<Route
					key={path}
					path={path}
					exact={exact}
					render={(props) => {
						// If past cutoff and this route is not allowed, redirect to booking
						if (isPastCutoff && !allowAfterCutoff) {
							return <Redirect to={'/booking'} />;
						}

						return (
							<Layout location={location}>
								<Component {...props} />
							</Layout>
						);
					}}
				/>
			))}
			<Route render={() => <Redirect to={'/booking'} />} />
		</Switch>
	);
};

export default Routes;
